import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CoverActions, MessagesActions, ValidationActions } from '../../../../actions';
import { BoxTitle, ImagePreview } from '../../../PageTemplate';
import { File, DoubleClickBtn } from '../../../Form';
import './upload.scss';
import { Box } from '../../../PageTemplate';

const {
    REACT_APP_FRAME_FILE_TYPES: REACT_APP_COVER_FILE_TYPES,
    REACT_APP_FRAME_MAX_FILE_SIZE: REACT_APP_COVER_MAX_FILE_SIZE,
} = process.env;

class UploadCover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventFinised: false,
            eventID: null,
            cover: null,
            file: null,
            fileInput: null,
            deleteCoverOk: false,
        }

        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleUploadSubmit = this.handleUploadSubmit.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised} = props;
        const {cover} = props.cover;
        const eventID = props.events.currentEventID;
        const newState = {};

        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;

        // if cover deleted
        if(!cover && state.cover) {
            newState.cover = null;

            // if user upload this cover (now) before delete it
            newState.file = null;
            newState.fileInput = null

            if(state.fileInput) state.fileInput.value = '';
        }

        // only if cover change
        if(cover && JSON.stringify(cover) !== JSON.stringify(state.cover)) {
            newState.cover = cover;
        }

        if(Object.keys(newState).length > 0) return newState;
        return null;
    }

    componentWillUnmount() {
        this.props.dispatch(CoverActions.resetCurrentCover());
    }

    handleFileChange(event) {
        if(!event || !event.target || !event.target.files || !event.target.files.length > 0 || this.state.eventFinised) return;
        var file = event.target.files[0];

        const {dispatch} = this.props;

        const validType = dispatch(ValidationActions.fileType(file.type, JSON.parse(REACT_APP_COVER_FILE_TYPES)));
        const validSize = dispatch(ValidationActions.fileSize(file.size, Number(REACT_APP_COVER_MAX_FILE_SIZE)));

        if(validType && validSize) {
            this.setState({file: file, fileInput: event.target}, this.handleUploadSubmit);
            return;
        }

        event.target.value = '';
        return this.setState({file: null});
    }

    handleUploadSubmit(event) {
        if(event) event.preventDefault();
        const {dispatch} = this.props;
        const {file, eventID} = this.state;

        if(!file) {
            dispatch(MessagesActions.pushInfo(`קודם צריך לבחור כיסוי`));
            return;
        }
        
        dispatch(CoverActions.uploadCover(eventID, {file}));
    }

    deleteCover() {
        const {dispatch, cover} = this.props;
        const currentCover = this.state.cover;

        if(cover.deleteCoverProcess === true || !currentCover._id || this.state.eventFinised) return;

        if(!this.state.deleteCoverOk) {
            return this.setState({deleteCoverOk: true});
        }

        this.setState({deleteCoverOk: false});
        dispatch(CoverActions.deleteCover(this.state.eventID, currentCover._id));
    }

    render() {
        const {cover} = this.state;
        const hasCoverUrl = cover && cover.url;
        const allowedFileTypes = "image/" + JSON.parse(REACT_APP_COVER_FILE_TYPES).join(",image/");
        const requestInProcess = this.props.cover.uploadCoverProcess;
        const deleteInProgress = this.props.cover.deleteCoverProcess;

        return (
            <Box col="1" id="uploadCoverSettings">
                <BoxTitle icon="faImage">
                    כיסוי
                </BoxTitle>
                <ImagePreview
                    image={hasCoverUrl || ""}
                    text="הוסיפו את כיסוי"
                />
                <div style={{display: `${hasCoverUrl ? 'block' : 'none'}`}}>
                    <form onSubmit={this.handleUpdateSubmit} className={`${!hasCoverUrl ? 'noFrame': ''}`}>     
                        <div className="inputRow">
                            <DoubleClickBtn
                                className={`deleteFile ${hasCoverUrl ? '' : 'hide'}`}
                                process={deleteInProgress}
                                clicked={this.state.deleteCoverOk}
                                icon="faTrashAlt"
                                textOne="מחיקה"
                                textTwo="בטוח?"
                                onClick={this.deleteCover.bind(this)}
                            />
                        </div>
                    </form>
                </div>
                <div style={{display: `${hasCoverUrl ? 'none' : 'block'}`}}>
                    <form onSubmit={this.handleUploadSubmit} className={`${!hasCoverUrl ? 'noFrame': ''}`}>
                        <div className="inputRow">
                            <File 
                                name="cover"
                                onChange={this.handleFileChange}
                                accept={allowedFileTypes}
                                placeholder="בחרו כיסוי"
                            />
                        </div>
                    </form>
                </div>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    const events = state.eventsReducer;
    const cover = { ...state.coverReducer };

    if (cover.cover && cover.cover.eventID !== events.currentEventID) {
        delete cover.cover;
    }

    return {
        events,
        cover
    }
}

const UploadWithRedux = connect(mapStateToProps)(UploadCover);

export {UploadWithRedux as UploadCover};



// WEBPACK FOOTER //
// ./src/components/EventPage/settings/cover/Upload.jsx